module.exports = __webpack_public_path__ + "static/img/cell1.8fbb3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cell1.png
// module id = m880
// module chunks = 0